import {
  CommunitiesOverviewResolver,
  CommunitiesResolver,
  CommunityResolver,
  EnergyKpiSiteResolver,
  EconomicsKpiSiteResolver,
  MemberResolver,
  MembersResolver,
  EconomicsKpiCommunityResolver,
  EnergyKpiCommunityResolver,
  EnergyCommunityRankingResolver,
  EconomicsCommunityRankingResolver,
  SiteOverviewResolver,
  EntitiesResolver,
  EnergyMemberRankingResolver,
  EconomicsMemberRankingResolver,
  EnergyKpiMemberResolver,
  EconomicsKpiMemberResolver,
  AncillaryKpiMemberResolver,
  AncillaryKpiCommunityResolver,
  AncillaryKpiSiteResolver,
  ComparisonKpiCommunityResolver,
  EconomicsCustomKpiMemberResolver,
  EconomicsCustomKpiCommunityResolver,
  EnergyCustomKpiCommunityResolver,
  EnergyCustomKpiMemberResolver,
  EconomicsCustomKpiSiteResolver,
  EnergyCustomKpiSiteResolver,
  KwickInvoicesResolver,
} from '@flexo/resolvers';

export const getResolver = (resolverName: string) => {

  switch (resolverName) {
    case 'MembersResolver':
      return MembersResolver;
    case 'CommunitiesResolver':
      return CommunitiesResolver;
    case 'CommunitiesOverviewResolver':
      return CommunitiesOverviewResolver;
    case 'MemberResolver':
      return MemberResolver;
    case 'CommunityResolver':
      return CommunityResolver;
    case 'EntitiesResolver':
      return EntitiesResolver;
    case 'EnergyKpiSiteResolver':
      return EnergyKpiSiteResolver;
    case 'EconomicsKpiSiteResolver':
      return EconomicsKpiSiteResolver;
    case 'EnergyKpiMemberResolver':
      return EnergyKpiMemberResolver;
    case 'EconomicsKpiMemberResolver':
      return EconomicsKpiMemberResolver;
    case 'EconomicsCustomKpiMemberResolver':
      return EconomicsCustomKpiMemberResolver;
    case 'EconomicsCustomKpiCommunityResolver':
      return EconomicsCustomKpiCommunityResolver;
    case 'EnergyCustomKpiMemberResolver':
      return EnergyCustomKpiMemberResolver;
    case 'EnergyCustomKpiCommunityResolver':
      return EnergyCustomKpiCommunityResolver;
    case 'EconomicsCustomKpiSiteResolver':
      return EconomicsCustomKpiSiteResolver;
    case 'EnergyCustomKpiSiteResolver':
      return EnergyCustomKpiSiteResolver;
    case 'EconomicsKpiCommunityResolver':
      return EconomicsKpiCommunityResolver;
    case 'EnergyKpiCommunityResolver':
      return EnergyKpiCommunityResolver;
    case 'EnergyCommunityRankingResolver':
      return EnergyCommunityRankingResolver;
    case 'EconomicsCommunityRankingResolver':
      return EconomicsCommunityRankingResolver;
    case 'SiteOverviewResolver':
      return SiteOverviewResolver;
    case 'EnergyMemberRankingResolver':
      return EnergyMemberRankingResolver;
    case 'EconomicsMemberRankingResolver':
      return EconomicsMemberRankingResolver;
    case 'AncillaryKpiMemberResolver':
      return AncillaryKpiMemberResolver;
    case 'AncillaryKpiCommunityResolver':
      return AncillaryKpiCommunityResolver;
    case 'AncillaryKpiSiteResolver':
      return AncillaryKpiSiteResolver;
    case 'ComparisonKpiCommunityResolver':
      return ComparisonKpiCommunityResolver;
    case 'KwickInvoicesResolver':
      return KwickInvoicesResolver;
    default:
      return null;
  }
};

export const getMetaResolver = (resolverName: string) => {
  switch (resolverName) {
    // case 'CommunityMetaResolver':
    //   return CommunityMetaResolver;
    default:
      return 'noData';
  }
};
